export const ACTION_SAVE_DASHBOARD_SYSTEM_STATUS = 'ACTION_SAVE_DASHBOARD_SYSTEM_STATUS';
export const ACTION_LOAD_CONCILIE_DATA = 'ACTION_LOAD_CONCILIE_DATA';
